import { render, staticRenderFns } from "./lotto-type-select.vue?vue&type=template&id=211c714b&"
import script from "./lotto-type-select.vue?vue&type=script&lang=js&"
export * from "./lotto-type-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports